import React from 'react';
import styled from 'styled-components';

import Header from '../components/header/Header';
import MonthsStatsSection from '../components/monthsStats/MonthsStatsSection';

const Health = () => {
  return (
    <HealthContainer>
      <Header />
      <MonthsStatsSection />
    </HealthContainer>
  );
};

const HealthContainer = styled.div`
  box-sizing: border-box;
  background: white;
  box-shadow: 0 5px 40px rgb(0 0 0 / 20%);
  max-width: 1366px;
  margin: auto;
  border-radius: 4px;
  margin-top: 20px;
  padding-bottom: 50px;
`;

export default Health;
